import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SharedIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SharedIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M15.2636 6.84034C15.0718 6.84034 14.8799 6.7671 14.7334 6.62061L11.9546 3.84229L9.17625 6.62061C8.88328 6.91358 8.40867 6.91358 8.1157 6.62061C7.82273 6.32764 7.82273 5.85303 8.1157 5.56006L11.4243 2.25147C11.7173 1.9585 12.1919 1.9585 12.4848 2.25147L15.7939 5.56006C16.0869 5.85303 16.0869 6.32764 15.7939 6.62061C15.6474 6.76709 15.4555 6.84034 15.2636 6.84034Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.9546 15.707C11.5405 15.707 11.2046 15.3711 11.2046 14.957V3.57618C11.2046 3.16212 11.5405 2.82618 11.9546 2.82618C12.3686 2.82618 12.7046 3.16212 12.7046 3.57618V14.957C12.7046 15.3711 12.3686 15.707 11.9546 15.707Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.2005 21.9675H4.79954C3.25592 21.9675 2 20.7115 2 19.1679V11.2739C2 10.8328 2.35794 10.4748 2.79913 10.4748C3.24031 10.4748 3.59825 10.8328 3.59825 11.2739V19.1679C3.59825 19.8302 4.13725 20.3692 4.79954 20.3692H19.2005C19.8628 20.3692 20.4017 19.8302 20.4017 19.1679V11.2739C20.4017 10.8328 20.7597 10.4748 21.2009 10.4748C21.6421 10.4748 22 10.8328 22 11.2739V19.1679C22 20.7115 20.7441 21.9675 19.2005 21.9675Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default SharedIcon;
